import { z } from 'zod';
import { paginationQueryResponse } from './pagination';

export const upComingLivesSchema = z.object({
  data: z.array(
    z.object({
      id: z.nullable(z.number()),
      documentId: z.nullable(z.string()),
      title: z.nullable(z.string()),
      date: z.nullable(z.string()),
      linkLive: z.nullable(z.string()),
      skillLevel: z.nullable(
        z.object({
          name: z.nullable(z.string()),
        }),
      ),
      featuredImage: z.nullable(z.object({ url: z.nullable(z.string()) })),
      teacherProfiles: z.nullable(
        z.array(
          z.object({
            displayName: z.nullable(z.string()),
            profilePicture: z.nullable(z.object({ url: z.nullable(z.string()) })),
          }),
        ),
      ),
    }),
  ),
  pagination: paginationQueryResponse,
});

export type UpComingLives = z.infer<typeof upComingLivesSchema>;
